import { render } from "./SmartHome.vue?vue&type=template&id=1b6f86e2"
import script from "./SmartHome.vue?vue&type=script&lang=js"
export * from "./SmartHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__